const bannerData = {
  text: 'Winter Season Launch Week is happening this week',
  url: 'https://go.novu.co/gFfjEj4?utm_source=web-top-banner',
  isActive: false,
  isReadMoreText: true,
};

export default bannerData;
